export const DownloadHelper = async (props = {}) => {
  const {
    fileId, baseUrl, authToken, sessionToken, fileName,
  } = props;

  const file = await fetch(`${baseUrl}storage/file/${fileId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'x-session-token': sessionToken,
    },
  }).catch((err) => {
    console.log(err);
  });

  if (!file || file?.status !== 200) {
    this.$toast.error('Ошибка сервера. Попробуйте позже');
    return;
  }

  const fileBlob = await file.blob();
  console.log(file?.url, 'file?.url');

  const fileNameStr = fileName || (file?.url || '').split('/').pop();

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(fileBlob);
  link.download = fileNameStr;

  document.body.appendChild(link);

  link.click();
};
